import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// views

import Dashboard from "views/admin/Dashboard.js";
import { useSelector } from "react-redux";
import Webinar from "views/admin/Webinar";
import Attendee from "views/admin/Attendee";
import UpdateWebinar from "views/admin/UpdateWebinar";





export default function Admin() {
  const { access } = useSelector((state) => state.auth);

  if (!access) {
    return <Redirect to="/login" />;
  }

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Switch>
            <Route path="/admin/dashboard" exact component={Dashboard} />
            <Route path="/admin/webinar" exact component={Webinar} />
             <Route path="/admin/webinar/:id" exact component={UpdateWebinar} />
            <Route path="/admin/webinars/:id/attendees" component={Attendee} />
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
